import { UserOrganizationItem } from "@/endpoints/dryp/backoffice";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FC } from "react";
import { Trash2 } from "lucide-react";
import { ROLE_OPTIONS } from "./constants";

interface AssignedOrganizationProps {
	assignment: UserOrganizationItem;
	onRoleChange: (organizationId: string, roleName: string) => void;
	onRemove: (organizationId: string) => void;
	updateLoading: boolean;
	removeLoading: boolean;
}

export const AssignedOrganization: FC<AssignedOrganizationProps> = ({
	assignment,
	onRoleChange,
	onRemove,
	updateLoading,
	removeLoading,
}) => {
	return (
		<div className="flex items-center gap-2">
			<span className="flex-1 text-sm truncate">{assignment.organizationName}</span>
			<Select
				value={assignment.roleName}
				onValueChange={value => onRoleChange(assignment.organizationId, value)}
				disabled={updateLoading}
			>
				<SelectTrigger className="w-32">
					<SelectValue />
				</SelectTrigger>
				<SelectContent>
					{ROLE_OPTIONS.map(role => (
						<SelectItem key={role.value} value={role.value}>
							{role.label}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
			<Button
				variant="ghost"
				size="icon"
				onClick={() => onRemove(assignment.organizationId)}
				disabled={removeLoading}
			>
				<Trash2 className="h-4 w-4 text-destructive" />
			</Button>
		</div>
	);
};
